<div>
  <div class="gt-page-header">
    <h1><i class="fa fa-bell"></i> {{ pageTitle }}</h1>
  </div>
  <div class="gt-page-body">
    <img src="assets/img/alerts.jpg" alt="Alerts">
  </div>
</div>
